import { FC, ReactNode } from 'react'

interface ConditionalWrapProps {
  children: React.JSX.Element
  condition: boolean
  wrap: (children: ReactNode) => React.JSX.Element
}

// https://gist.github.com/kitze/23d82bb9eb0baabfd03a6a720b1d637f
// Think this is a common pattern for the CMS components
export const ConditionalWrap: FC<ConditionalWrapProps> = ({
  children,
  condition,
  wrap,
}: ConditionalWrapProps) => (condition ? wrap(children) : children)
